// extracted by mini-css-extract-plugin
module.exports = {"block":"footer_block__38hgx","social":"footer_social__38_2v","link":"footer_link__OGCNx","copyright":"footer_copyright__WJzhY","contacts":"footer_contacts__3Pim1"};